import { render, staticRenderFns } from "./NewXTROrderView.vue?vue&type=template&id=31b5dd5a&"
import script from "./NewXTROrderView.vue?vue&type=script&lang=js&"
export * from "./NewXTROrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports